/**
 * Leaf enums shared by `index.ts` and the files it re-exports.
 *
 * They live apart from `index.ts` because those files need them at module
 * evaluation time, and importing them back from `index.ts` would be a cycle
 * that leaves them uninitialised. Nothing here imports anything but zod.
 */

import { z } from "zod";

/** OS enum matching VeilBrowser profile naming */
export const OsSchema = z
	.enum(["win", "mac", "linux", "android"])
	.describe("Operating system type");

/** Architecture enum for profile detection */
export const ArchSchema = z
	.enum(["x64", "x86", "arm64", "unknown"])
	.describe("CPU architecture");

/** Windows version enum (user-friendly) */
export const WindowsVersionSchema = z
	.enum(["7", "10", "11"])
	.describe("User-friendly Windows version");

export type WindowsVersion = z.infer<typeof WindowsVersionSchema>;

/** Proxy type enum */
export const ProxyTypeSchema = z
	.enum(["http", "https", "socks5", "socks5h"])
	.describe("Proxy protocol type");
